import options from './general-information.component';

export default {
    selector: 'dtGeneralInformation',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/general-information/index.js